"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyMembersOverview = exports.Tag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const tags_1 = require("../../atoms/tags");
const commonStyles = `
  display: grid;
  grid-template-columns: 2rem 1fr 5rem 1fr 1fr 1.5fr 1.5fr;
  grid-column-gap: 1rem;
`;
const TableHeader = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: "#" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("monthlyOverview.name") }, void 0), (0, jsx_runtime_1.jsx)("div", {}, void 0), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("monthlyOverview.from") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("monthlyOverview.to") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("monthlyOverview.reasonIn") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("monthlyOverview.reasonOut") }, void 0)] }, void 0));
};
const Header = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
  ${commonStyles};
  padding: ${({ theme }) => `${theme.spacings.s} ${theme.spacings.m}`};
  position: sticky;
  top: 4rem;

  & h2 {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
    margin-bottom: 0;
  }
`;
const renderEventReason = (key, isDisabled) => (event, idx) => ((0, jsx_runtime_1.jsx)(MaxWidth, { isDisabled: isDisabled, children: event[key] }, idx));
const renderEventDate = (key, isDisabled) => (event, idx) => {
    const isBoldDate = !!((key === "from" && event.reasonIn) ||
        (key === "to" && event.reasonOut));
    return ((0, jsx_runtime_1.jsx)(MaxWidth, { isBold: isBoldDate, isDisabled: isDisabled, children: event[key] }, idx));
};
const TableRow = ({ overview, index, onClick }) => {
    const { events, name, isDisabled } = overview;
    return ((0, jsx_runtime_1.jsxs)(Row, { isDisabled: isDisabled, children: [(0, jsx_runtime_1.jsx)(Column, { children: (0, jsx_runtime_1.jsx)(MaxWidth, { isDisabled: isDisabled, children: `${index + 1}.` }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Column, { className: "name", onClick: onClick, children: (0, jsx_runtime_1.jsx)(MaxWidth, { isDisabled: isDisabled, children: name }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Column, { className: "subscriptions", children: events.map((event, idx) => ((0, jsx_runtime_1.jsx)(MaxWidth, { children: (0, jsx_runtime_1.jsx)(exports.Tag, { isDisabled: isDisabled, subscription: event.subscriptionType, children: event.subscriptionType }, void 0) }, event.subscriptionType + idx))) }, void 0), (0, jsx_runtime_1.jsx)(Column, { children: overview.events.map(renderEventDate("from", isDisabled)) }, void 0), (0, jsx_runtime_1.jsx)(Column, { children: overview.events.map(renderEventDate("to", isDisabled)) }, void 0), (0, jsx_runtime_1.jsx)(Column, { children: events.map(renderEventReason("reasonIn", isDisabled)) }, void 0), (0, jsx_runtime_1.jsx)(Column, { children: events.map(renderEventReason("reasonOut", isDisabled)) }, void 0)] }, void 0));
};
const Column = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const MaxWidth = styled_components_1.default.div `
  align-items: center;
  color: ${({ isDisabled, theme }) => isDisabled ? theme.colors.silverLighten60 : theme.colors.greyBase};
  display: flex;
  font-weight: ${({ isBold }) => (isBold ? 600 : 400)};
  min-height: 2rem;
  width: 100%;
`;
exports.Tag = (0, styled_components_1.default)(tags_1.Tag) `
  ${({ isDisabled, theme }) => isDisabled
    ? `
    background-color: ${theme.colors.silverBase};
    
    & > span {
      color: ${theme.colors.silverLighten60};
    }
  `
    : ""}
`;
const Row = styled_components_1.default.div `
  ${commonStyles};

  .name {
    pointer-events: ${({ isDisabled }) => isDisabled ? "none" : "auto"};
  }

  .name:hover {
    cursor: ${({ isDisabled }) => (isDisabled ? "unset" : "pointer")};
    text-decoration: ${({ isDisabled }) => isDisabled ? "none" : " underline"};
  }

  .subscriptions {
    & div > span {
      margin: 0;
      text-align: center;
      width: 70px;
    }
  }

  .days div > span {
    display: inline-block;
    margin-left: 0;
    text-align: center;
    width: 2rem;

    & > span {
      color: ${({ theme }) => theme.colors.greyBase};
    }
  }
`;
const MonthlyMembersOverview = ({ membersOverview, onMemberClick }) => {
    const onClick = (id) => () => onMemberClick(id);
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsx)(TableHeader, {}, void 0), (0, jsx_runtime_1.jsx)("div", { children: membersOverview.map((overview, idx) => ((0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsx)(TableRow, { overview: overview, index: idx, onClick: onClick(overview.id) }, void 0) }, overview.name + idx))) }, void 0)] }, void 0));
};
exports.MonthlyMembersOverview = MonthlyMembersOverview;
const Container = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-top: none;

  & > div:last-of-type > div {
    padding: ${({ theme }) => `${theme.spacings.xs} ${theme.spacings.m}`};

    &:not(:first-of-type) {
      padding-top: 0;
    }
  }

  & > div:last-of-type > div:not(:last-of-type) > div {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    padding-bottom: ${({ theme }) => theme.spacings.xs};
  }
`;
//# sourceMappingURL=index.js.map